import { buildSpectateUrl } from '../../spa/Utils/Spectate';
import { get, post } from '../utils/http';
import { GET_VIRTUALS_GAMES, GET_IFRAME_DATA } from '../../spa/Pages/VirtualSports/constants';
import { getBbClientStateCache } from '../utils/bb-client-state';
import { isIosApp } from '../utils/user';

const BB_CLIENT_STATE_KEY = 'customer:virtualSportsList';
const BB_CLIENT_STATE_CACHE_TTL = 300000; // 5m

const { setBbClientStateCached, getBbClientStateCached, clearBbClientStateCached } = getBbClientStateCache(BB_CLIENT_STATE_KEY, BB_CLIENT_STATE_CACHE_TTL);

/**
 * Clears the virtual sports list from bBClientState
 * @export
 * @returns {Void} just that
 */
export const clearVirtualGamesCache = () => clearBbClientStateCached();

/**
 * Retrieve the cached virtual sports list from bBClientState (if exists)
 * @return {Array|undefined} the list or null
 */
const getVirtualGamesCache = () => getBbClientStateCached();

/**
 * Sets the virtual sports list in bBClientState and celars/sets a timeout to invalidate
 * @param {Array} list virtual games
 * @returns {Void} Missing JSDoc return description
 */
const setVirtualGamesCache = (list) => {
    setBbClientStateCached(list);
};

/**
 * Disabling a specific virtual game when necessary
 * This ain't pretty but covers a specific case of some games not working on certain platforms
 * @param {Array} virtualGames Array of virtual games
 * @return {Array} filteredGames
 */
export const filterVirtualGame = (virtualGames) => {
    // 2 games don't work on ios/app
    if (isIosApp()) {
        const disabledGameSlugs = ['virtual-golf', 'euroleague-legends'];

        return virtualGames.filter(item => !disabledGameSlugs.includes(item.game_slug));
    }

    return virtualGames;
};

/**
 * Gets list of virtual sports games. Try to retrieve from cache and if empty call BE and set cache
 * @return {Array} List of games or empty array
 */
export async function getVirtualGames() {
    const virtuals = getVirtualGamesCache();
    if (typeof virtuals !== 'undefined') {

        return virtuals;
    }

    const endpointUrl = buildSpectateUrl(GET_VIRTUALS_GAMES);
    const response = await get(endpointUrl);

    if (response.ok) {
        const virtualGames = await response.json();
        if (virtualGames) {
            const filteredVirtualGames = filterVirtualGame(virtualGames);
            setVirtualGamesCache(filteredVirtualGames);

            return filteredVirtualGames;
        }
    }

    return [];
}

/**
 * Get a virtual game object from BE response
 * @param {Array} games the list of virtual games
 * @param {String} slug the game slug
 * @throws {Error} Your calling code should check that you have a valid games array
 * @returns {Object} the game object or {}
 */
export function getVirtualGameBySlug(games, slug) {
    if(!Array.isArray(games)) {
        throw new Error('getVirtualGameBySlug() games param must be an array');
    }
    const foundSport = games.find(virtualSport => virtualSport.game_slug === slug);

    return (typeof foundSport !== 'undefined' ? foundSport : {});
}

/**
 * Gets data to load iframe
 * @return {Array} iframe data
 */
export async function getIframeData() {
    const endpointUrl = buildSpectateUrl(GET_IFRAME_DATA);

    const response = await post(endpointUrl);
    if (response.ok) {
        const responseJson = await response.json();
        if (responseJson) {

            return responseJson;
        }
    }

    return [];
}

